import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DropdownModule } from 'primeng/dropdown';
import {
    TranslateModule,
    TranslatePipe,
    TranslateService,
} from '@ngx-translate/core';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NormalizingTranslateService } from '@qwyk/core';
import { TranslateConfigChild } from '@qwyk/portals/translation';

import {
    LoginFormComponent,
    LoginModalComponent,
    ResetPasswordFormComponent,
    RequestPasswordResetFormComponent,
} from './components';
import * as fromAuthentication from './state/authentication.reducer';
import { AuthenticationFacade } from './state/authentication.facade';
import { AuthenticationEffects } from './state/authentication.effects';
import { ResendConfirmationEmailComponent } from './components/resend-confirmation-email/resend-confirmation-email.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        DropdownModule,
        FontAwesomeModule,
        DynamicDialogModule,
        ReactiveFormsModule,
        StoreModule.forFeature(
            fromAuthentication.AUTHENTICATION_FEATURE_KEY,
            fromAuthentication.reducer
        ),
        EffectsModule.forFeature([AuthenticationEffects, DynamicDialogRef]),
        TranslateModule.forChild(TranslateConfigChild),
        TranslatePipe,
    ],
    providers: [
        AuthenticationFacade,
        { provide: TranslateService, useClass: NormalizingTranslateService },
    ],
    declarations: [
        LoginModalComponent,
        LoginFormComponent,
        ResetPasswordFormComponent,
        RequestPasswordResetFormComponent,
        ResendConfirmationEmailComponent,
    ],
    exports: [ResendConfirmationEmailComponent],
})
export class PortalsAuthenticationModule {}
